import { CreateAccountFormContext } from "@store/Widgets/CreateAccount/CreateAccountForm";
import { useContext, useEffect } from "react";

const useFieldValidation = (key: string, value: string | undefined, validate: () => boolean) => {
    const createAccountFormContext = useContext(CreateAccountFormContext);

    useEffect(() => {
        createAccountFormContext.validators[key] = validate;
        if (typeof value !== "undefined") {
            validate();
        }
    }, [value]);
};

export const useConditionalFieldValidation = (
    key: string,
    value: string | undefined,
    conditional: boolean,
    validate: () => boolean,
) => {
    const createAccountFormContext = useContext(CreateAccountFormContext);

    useEffect(() => {
        if (conditional) {
            createAccountFormContext.validators[key] = validate;
        } else {
            delete createAccountFormContext.validators[key];
        }
        if (typeof value !== "undefined" && conditional) {
            validate();
        }
    }, [value, conditional]);
};

export default useFieldValidation;
